import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { IsaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/IsaContributionInstruction";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { GiaContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/GiaContributionInstruction";
import { WrapCashContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/WrapCashContributionInstruction";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { SPTInstructionDispatcher, SPTInstructionStore } from "../Store/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { CommissionChargesClient } from "../../../../../../Wrap/Api/Charge/CommissionCharges";
import { InstructionProcessClient } from "../../../../../../Wrap/Api/Instruction/InstructionProcess";
import { ContributionAndWithdrawalBase } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";
import { PensionSubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionSubAccountAmendmentInstruction";

export class SPTAction {
    public static getInstruction(id, type, hierarchyId, subAccountHierarchyId, clientId): void {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            this.getOrCreateInstruction(
                pensionContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId
            );
        } else if (SubAccountTypeHelper.isPP(type)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            this.getOrCreateInstruction(giaContributionInstruction, id, hierarchyId, subAccountHierarchyId, clientId);
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const isaContributionInstruction = new IsaContributionInstructionClient();
            this.getOrCreateInstruction(isaContributionInstruction, id, hierarchyId, subAccountHierarchyId, clientId);
        } else if (SubAccountTypeHelper.isWrapCash(type)) {
            const wrapCashContributionInstruction = new WrapCashContributionInstructionClient();
            this.getOrCreateInstruction(
                wrapCashContributionInstruction,
                id,
                hierarchyId,
                subAccountHierarchyId,
                clientId
            );
        } else {
            SPTInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: {
                    HierarchyId: "034-0000006631",
                    ownerHierarchyId: "000-0000738253",
                    ClientDetails: null,
                    AllBankAccounts: [],
                    Contribution: null,
                    WrapCash: {
                        ClientSinglePayment: null,
                        EmployerSinglePayment: null,
                        ThirdPartySinglePayment: null,
                    },
                    BankAccountInstructions: [],
                },
            });
        }
    }

    public static saveInstruction(from, data: any, type, customerId?: number, callback?: (data) => void): void {
        if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            const pensionContributionInstruction = new PensionContributionInstructionClient();
            const promise = pensionContributionInstruction.put(data, customerId,null);
            this.updateSPTInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isPP(type)) {
            const giaContributionInstruction = new GiaContributionInstructionClient();
            const promise = giaContributionInstruction.put(data, "");
            this.updateSPTInstructionStore(promise, callback);
        } else if (SubAccountTypeHelper.isIsa(type)) {
            const client = new IsaContributionInstructionClient();
            const promise = client.put(data);
            this.updateSPTInstructionStore(promise, callback);
        } else if (type == SubAccountType.WrapCash) {
            const client = new WrapCashContributionInstructionClient();
            const promise = client.put(data);
            this.updateSPTInstructionStore(promise, callback);
        } else {
            callback([]);
        }
    }

    public static postInstructionProcess(instructionId: number, processType: ActivityType) {
        const client = new InstructionProcessClient();
        const promise = client.post(instructionId, processType);
    }

    public static submitInstruction(
        hierarchyId: string,
        data: ContributionAndWithdrawalBase,
        customerId,
        clAcclountId,
        subAccountType,
        callback?: VoidFunction
    ): void {
        const client = subAccountType === SubAccountType.Npr ? new PensionSubAccountAmendmentInstructionClient() : new SubAccountAmendmentInstructionClient();
        const promise = client.put(hierarchyId, data, customerId, clAcclountId);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static cancelCommissionCharges(
        instructionId: number,
        headAccountHierarchyId: string,
        subAccountHierarchyId: string,
        cancelAll: boolean,
        callback?: VoidFunction
    ) {
        const client = new CommissionChargesClient();
        const promise = client.delete(headAccountHierarchyId, cancelAll, subAccountHierarchyId, instructionId);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static getCommissionCharges(headAccountHierarchyId: string, callback?) {
        const client = new CommissionChargesClient();
        const promise = client.get(headAccountHierarchyId);
        promise.onSuccess((result) => {
            if (callback) {callback(result);}
        });
    }

    private static getOrCreateInstruction(
        client:
            | PensionContributionInstructionClient
            | IsaContributionInstructionClient
            | GiaContributionInstructionClient
            | WrapCashContributionInstructionClient,
        id,
        hierarchyId,
        subAccountHierarchyId,
        clientId
    ) {
        if (id && id !== "") {
            // Have instructionId
            const promise = client.get(id, clientId, "", null);
            this.updateSPTInstructionStore(promise);
        } else {
            // Create new instruction
            const promise = client.post(subAccountHierarchyId, hierarchyId, ActivityType.AddSinglePaymentorTransfer);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const model = client.get(instructionId, clientId, "", null);
                this.updateSPTInstructionStore(model);
            });

            promise.onError((err) => {
                SPTInstructionDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
        }
    }

    private static updateSPTInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            let data = JSON.parse(JSON.stringify(SPTInstructionStore.getData()));
            if (!data) {data = {};}
            data = result;
            SPTInstructionDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (result.Errors != null && result.Errors.length > 0) {
                callback(result.Errors);
            } else {
                callback(data);
            }
        });

        promise.onError((err) => {
            SPTInstructionDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
